import './scss/style.scss';
import 'tiny-slider/dist/tiny-slider.css';
import { tns } from 'tiny-slider/src/tiny-slider';

document.addEventListener('DOMContentLoaded', () => {
	window.dataLayer = window.dataLayer || [];

	const steps = document.querySelectorAll('.step');
	const stepsImage = document.querySelector('.steps-image img');

	steps.forEach((step) => {
		step.addEventListener('mouseenter', () => {
			const newImage = step.getAttribute('data-image');
			if (newImage) {
				stepsImage.style.opacity = 0;
				setTimeout(() => {
					stepsImage.setAttribute('src', newImage);
					stepsImage.style.opacity = 1;
				}, 300);
			}
		});

		step.addEventListener('mouseleave', () => {
			stepsImage.style.opacity = 0;
			setTimeout(() => {
				stepsImage.setAttribute('src', '/images/how-it-works-1.png');
				stepsImage.style.opacity = 1;
			}, 300);
		});
	});

	const faqItems = document.querySelectorAll('.faq-item');
	faqItems.forEach((item) => {
		const question = item.querySelector('.faq-item-question');
		question.addEventListener('click', () => {
			if (item.classList.contains('active')) {
				item.classList.remove('active');
			} else {
				faqItems.forEach((i) => i.classList.remove('active'));
				item.classList.add('active');
				window.dataLayer=window.dataLayer||[];
				window.dataLayer.push({
					event:'faq_clicks',
					faq_question:item.querySelector('h3').textContent.trim(),
				});
			}
		});
	});


	const carouselBenefits = tns({
		container: '#why-us-benefits',
		items: 3.5,
		center: true,
		loop: false,
		slideBy: 'page',
		autoplay: false,
		controls: false,
		speed: 400,
		gutter: 32,
		mouseDrag: true,
		controlsContainer: false,
		nav: false,
		slideBy: 1,
		responsive: {
			1: {
				items: 1,
				gutter: 0,
				edgePadding: 0,
			},
			993: {
				items: 3.5,
				gutter: 32,
				edgePadding: 0,
			},
		},
	});

	document.querySelector('#benefits-navigation-left').addEventListener('click', function () {
		carouselBenefits.goTo('prev');
	});

	document.querySelector('#benefits-navigation-right').addEventListener('click', function () {
		carouselBenefits.goTo('next');
	});

	document.querySelector('#burger').addEventListener('click', function () {
		document.querySelector('#burger-list').classList.toggle('active');
		document.querySelector('#burger-open').style.display = document.querySelector('#burger-list').classList.contains('active') ? 'none' : 'block';
		document.querySelector('#burger-close').style.display = document.querySelector('#burger-list').classList.contains('active') ? 'block' : 'none';
	});

	carouselBenefits.events.on('transitionEnd', function (info) {
		if (info.displayIndex === 1) {
			document.querySelector('#benefits-navigation').classList.add('slide-first');
			document.querySelector('#benefits-navigation').classList.remove('slide-last');
		} else if (info.displayIndex === info.slideCount) {
			document.querySelector('#benefits-navigation').classList.remove('slide-first');
			document.querySelector('#benefits-navigation').classList.add('slide-last');
		} else {
			document.querySelector('#benefits-navigation').classList.remove('slide-first');
			document.querySelector('#benefits-navigation').classList.remove('slide-last');
		}
	});

	const carouselProducers = tns({
		container: '#producers-carousel',
		// center: true,
		controls: false,
		gutter: 0,
		mouseDrag: false,
		controlsContainer: false,
		nav: false,
		slideBy: 1,
		touch: true,
		autoplay: true,
		autoplayHoverPause: false,
		autoplayTimeout: 3000,
		speed: 400,
		autoplayButton: false,
		autoplayButtonOutput: false,
		loop: true,
		responsive: {
			1: {
				items: 2,
				gutter: 0,
				edgePadding: 0,
			},
			993: {
				items: 6,
				gutter: 32,
			},
		},
	});

	const carouselPartners = tns({
		container: '#partners-carousel',
		// center: true,
		controls: false,
		gutter: 0,
		mouseDrag: true,
		controlsContainer: false,
		nav: false,
		slideBy: 1,
		touch: true,
		autoplay: true,
		autoplayHoverPause: false,
		autoplayTimeout: 5000,
		speed: 400,
		autoplayButton: false,
		autoplayButtonOutput: false,
		loop: true,
		responsive: {
			1: {
				items: 1,
				gutter: 0,
				edgePadding: 0,
			},
			993: {
				items: 1,
				gutter: 32,
			},
		},
	});

});
